import { AxiosError } from "axios";

type FleeterErrorBody = {
	type?: string;
	title?: string;
	status?: number;
	detail?: string;
	errors?: string[];
	fieldsErrors?: Record<string, string[]>;
};

function getFleeterError(error: unknown): FleeterErrorBody | null {
	if (!(error instanceof AxiosError)) {
		return null;
	}

	const data = error.response?.data;
	const body = data?.error ?? data;
	if (!body || typeof body !== "object") {
		return null;
	}

	return body as FleeterErrorBody;
}

export function getExportErrorMessage(
	error: unknown,
	fallback = "Não foi possível solicitar a exportação. Tente novamente."
): string {
	const errorData = getFleeterError(error);

	if (errorData?.errors && errorData.errors.length > 0) {
		return errorData.errors[0];
	}

	if (errorData?.detail) {
		return errorData.detail;
	}

	if (error instanceof AxiosError && error.response?.status === 403) {
		return "Você não tem permissão para executar esta ação.";
	}

	return fallback;
}

/**
 * 400 without field errors = "no data for filters" (or missing email).
 * Keep the modal open and show an informative toast.
 */
export function isExportNoDataError(error: unknown): boolean {
	if (!(error instanceof AxiosError)) {
		return false;
	}

	if (error.response?.status !== 400) {
		return false;
	}

	const errorData = getFleeterError(error);
	if (!errorData) {
		return false;
	}

	const fieldsErrors = errorData.fieldsErrors;
	const hasFieldErrors = Object.keys(fieldsErrors ?? {}).length > 0;

	return !hasFieldErrors;
}
